
import qs from 'qs';
import '@ers/extenders/object';
import '@ers/extenders/string';
import { RequestParser } from './api';

class UrlHelper {
    get hash() {
        return HashHelper;
    }

    get query() {
        return QueryHelper;
    }
}

class HashHelper {
    static get() {
        const params = window.location.hash.slice(1);
        const obj = qs.parse(params);
        return obj;
    }

    static getTrimmed(paramsToDelete) {
        const obj = this.get();
        return obj.extensions.trim(paramsToDelete);
    }

    static getUrlWithTrimmed(params) {
        if (!params.length) { return window.location.toString() }
        const trimmed = this.getTrimmed(params);
        const hash = `${RequestParser.toQueryString(trimmed)}`;
        const [currentUrl] = window.location.href.split('#');
        return `${currentUrl}#${hash}`;
    }
}
class QueryHelper {
    static get() {
        const params = window.location.search.slice(1);
        const obj = qs.parse(params);
        return obj;
    }
}

export default UrlHelper;